export default __webpack_public_path__ + "static/media/group-599.e2e7744a.png";